import http from 'lib/utils/axios';

const IDENTIFICATION_URL = '/identification/';

export const fetchTypes = () => http.get(`${IDENTIFICATION_URL}types`);
export const fetchCountries = () => http.get(`${IDENTIFICATION_URL}countries`);

export const fetchIdentification = () => http.get(IDENTIFICATION_URL);
export const updateIdentification = payload => http.post(IDENTIFICATION_URL, payload);

export default {
  fetchTypes,
  fetchCountries,
  fetchIdentification,
  updateIdentification,
};
